import { render } from "./PriceBox.vue?vue&type=template&id=5ea7ba18&scoped=true"
import script from "./PriceBox.vue?vue&type=script&lang=js"
export * from "./PriceBox.vue?vue&type=script&lang=js"

import "./PriceBox.vue?vue&type=style&index=0&id=5ea7ba18&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_736573a84b094314044e4eeca7aa4b54/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea7ba18"]])

export default __exports__